import HeaderSimple from "../HeaderSimple/HeaderSimple.vue"
import ResponsiveFooter from "../responsivefooter/ResponsiveFooter.vue"

export default {
  name: 'log-out',
  components: {
    HeaderSimple,
    responsivefooter: ResponsiveFooter
  },
  props: [],
  created(){
    localStorage.removeItem('access-token')
    localStorage.removeItem('refresh-token')
  }

}

